import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior: function (to) {
        if (to.hash) {
            return {selector: to.hash}
        }
    },
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'main',
            component: () => import('./views/Main.vue'),
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/account/Login.vue'),
        },
        {
            path: '/account/reset_pw/:token',
            name: 'pw_reset_with_token',
            component: () => import('./views/account/TokenPassword.vue'),
        },
        {
            path: '/account/verify_email/:token',
            name: 'verify_email',
            component: () => import('./views/account/VerifyEmail.vue'),
        },
        {
            path: '/account/forgot',
            name: 'forgot_password',
            component: () => import('./views/account/ForgotPassword.vue'),
        },
        {
            path: '/account',
            name: 'account',
            component: () => import('./views/account/AccountOverview.vue'),
        },
        {
            path: '/account/mpsk',
            name: 'account_mpsk',
            component: () => import('./views/account/MPSK.vue'),
        },
        {
            path: '/account/cards',
            name: 'account_cards',
            component: () => import('./views/account/Cards.vue'),
        },
        {
            path: '/wifi',
            name: 'wifi',
            component: () => import('./views/pages/WiFi.vue'),
        },
        {
            path: '/wlan',
            redirect: '/wifi'
        },
        {
            path: '/imprint',
            name: 'imprint',
            component: () => import('./views/pages/Imprint'),
        },
        {
            path: '/privacy',
            name: 'privacy_policy',
            component: () => import('./views/pages/Privacy'),
        },
        {
            path: '/faq',
            name: 'faq',
            component: () => import('./views/pages/FAQ.vue'),
        },
        {
            path: '/my_dorm/tutors',
            name: 'tutor',
            component: () => import('./views/dorm/Tutors'),
        },
        {
            path: '/my_dorm/common_rooms',
            name: 'common_rooms',
            component: () => import('./views/dorm/CommonRooms'),
        },
        {
            path: '/my_dorm/common_rooms/:room_id',
            name: 'manage_common_room',
            component: () => import('./views/dorm/ManageCommonRoom'),
        },
        {
            path: '/admin/tenants',
            name: 'admin_tenants',
            component: () => import('./views/admin/TenantSerach'),
        },{
            path: '/admin/tutors',
            name: 'admin_tutors',
            component: () => import('./views/admin/TutorsAdmin'),
        },{
            path: '/admin/semester',
            name: 'admin_semester',
            component: () => import('./views/admin/SemesterAdmin'),
        },
    ]
})
